import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import { PLAYER_ACTION_TYPE } from './attributionConstants';
import AppCommonSelectControl from '../../../common/inputs/common/AppCommonSelectControl';
import useClickOutside from '../../../common/hooks/useClickOutside';
import useHandleEsc from '../../../common/hooks/useHandleEsc';
import './player-action-select.scss';

const ACTIVE_COLOR = '#5f5f8b';
const TEXT_COLOR = '#495057';
const SECONDARY_TEXT_COLOR = '#898996';

function GameplayCategoryIcon({ isActive }) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.9789 5.34278L9.74403 4.10791C9.23619 3.60007 9.54653 3.06402 10.0999 3.03147C11.0114 2.97504 11.5236 2.00277 10.7792 1.19327C9.96973 0.451049 9.0018 0.961056 8.94538 1.87039C8.91065 2.4238 8.37026 2.73631 7.8646 2.23065L6.65577 1.02182C6.29334 0.659392 5.70521 0.659392 5.34278 1.02182L4.11876 2.24584C3.61092 2.75368 3.0727 2.43899 3.03798 1.88558C2.98155 0.974078 2.00494 0.45539 1.19544 1.19978C0.448879 2.01145 0.967567 2.98806 1.87907 3.04449C2.43248 3.07921 2.74717 3.6196 2.2415 4.12744L1.02182 5.34495C0.659392 5.70738 0.659392 6.29551 1.02182 6.65794L2.23065 7.86677C2.73848 8.37243 2.43682 8.8998 1.88341 8.93453C0.971907 8.99095 0.4619 9.96105 1.20629 10.7706C2.01579 11.5149 2.98155 11.0071 3.03798 10.0956C3.0727 9.54219 3.60224 9.23836 4.11008 9.74403L5.32975 10.9637C5.69869 11.3326 6.30202 11.3326 6.67096 10.9659L7.52604 10.1108L7.89281 9.74403C8.37243 9.2427 8.06209 8.71533 7.51519 8.68061C6.60369 8.62418 6.08717 7.64757 6.83156 6.83807C7.64106 6.09368 8.61767 6.61237 8.6741 7.52387C8.70882 8.07077 9.23402 8.37894 9.73535 7.89932L10.0674 7.56727L10.9615 6.67313C10.9637 6.67096 10.9637 6.67096 10.9659 6.66879L10.9789 6.65577C11.3413 6.29334 11.3413 5.70521 10.9789 5.34278Z"
                stroke={isActive ? ACTIVE_COLOR : SECONDARY_TEXT_COLOR}
                strokeWidth="0.675"
            />
        </svg>
    );
}
function AccountCategoryIcon({ isActive }) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.91376 5.78046C6.70789 5.78046 7.39545 5.49564 7.9574 4.93369C8.51916 4.37183 8.80408 3.68436 8.80408 2.89014C8.80408 2.09619 8.51926 1.40863 7.95731 0.846588C7.39535 0.284821 6.70779 0 5.91376 0C5.11954 0 4.43207 0.284821 3.87021 0.84668C3.30835 1.40854 3.02344 2.0961 3.02344 2.89014C3.02344 3.68436 3.30835 4.37192 3.87021 4.93378C4.43225 5.49554 5.11981 5.78046 5.91376 5.78046ZM4.36752 1.3439C4.79864 0.912781 5.30438 0.703217 5.91376 0.703217C6.52304 0.703217 7.02887 0.912781 7.46008 1.3439C7.8912 1.77512 8.10086 2.28095 8.10086 2.89014C8.10086 3.49951 7.8912 4.00525 7.46008 4.43646C7.02887 4.86768 6.52304 5.07724 5.91376 5.07724C5.30457 5.07724 4.79883 4.86758 4.36752 4.43646C3.93631 4.00534 3.72665 3.49951 3.72665 2.89014C3.72665 2.28095 3.93631 1.77512 4.36752 1.3439Z"
                fill="#898996"
            />
            <path
                d="M10.9718 9.22586C10.9556 8.99204 10.9228 8.73697 10.8745 8.46762C10.8258 8.19626 10.7631 7.93973 10.688 7.70526C10.6104 7.46292 10.505 7.2236 10.3746 6.99426C10.2393 6.75623 10.0804 6.54895 9.90207 6.37839C9.71558 6.19995 9.48724 6.05649 9.2232 5.95184C8.96008 5.84775 8.66849 5.79501 8.35657 5.79501C8.23407 5.79501 8.1156 5.84528 7.88681 5.99423C7.746 6.08606 7.5813 6.19226 7.39746 6.30972C7.24026 6.40988 7.02731 6.50372 6.76428 6.58868C6.50766 6.67172 6.2471 6.71384 5.98984 6.71384C5.73276 6.71384 5.4722 6.67172 5.21539 6.58868C4.95264 6.50381 4.73959 6.40997 4.58267 6.30981C4.40057 6.19345 4.23578 6.08725 4.09286 5.99414C3.86426 5.84518 3.74579 5.79492 3.62329 5.79492C3.31128 5.79492 3.01978 5.84775 2.75674 5.95193C2.49289 6.0564 2.26447 6.19986 2.07779 6.37848C1.89944 6.54913 1.74051 6.75632 1.60538 6.99426C1.4751 7.2236 1.36963 7.46283 1.29199 7.70535C1.21701 7.93982 1.1543 8.19626 1.10559 8.46762C1.05725 8.7366 1.02457 8.99176 1.00836 9.22614C0.992432 9.45529 0.984375 9.69379 0.984375 9.93475C0.984375 10.5612 1.1835 11.0683 1.57617 11.4423C1.96399 11.8113 2.47705 11.9984 3.10117 11.9984H8.87924C9.50317 11.9984 10.0162 11.8113 10.4041 11.4423C10.7969 11.0685 10.996 10.5612 10.996 9.93466C10.9959 9.69287 10.9878 9.45438 10.9718 9.22586ZM9.91928 10.9328C9.66302 11.1767 9.32281 11.2952 8.87915 11.2952H3.10117C2.65741 11.2952 2.3172 11.1767 2.06104 10.9329C1.80972 10.6936 1.68759 10.3671 1.68759 9.93475C1.68759 9.7099 1.69501 9.48788 1.70984 9.27475C1.7243 9.06564 1.75388 8.83594 1.79773 8.59186C1.84103 8.3508 1.89615 8.12457 1.9617 7.91977C2.0246 7.72339 2.11038 7.52893 2.21677 7.34161C2.3183 7.16309 2.43512 7.00992 2.56403 6.88651C2.6846 6.77106 2.83658 6.67657 3.01566 6.60571C3.18127 6.54016 3.3674 6.50427 3.56946 6.49887C3.59409 6.51196 3.63794 6.53696 3.70898 6.58328C3.85355 6.67749 4.02017 6.78497 4.20438 6.90262C4.41202 7.035 4.67953 7.15457 4.99915 7.25775C5.3259 7.3634 5.65915 7.41705 5.98993 7.41705C6.32071 7.41705 6.65405 7.3634 6.98062 7.25784C7.30051 7.15448 7.56793 7.035 7.77585 6.90244C7.96435 6.78195 8.12631 6.67758 8.27087 6.58328C8.34192 6.53705 8.38577 6.51196 8.4104 6.49887C8.61255 6.50427 8.79868 6.54016 8.96439 6.60571C9.14337 6.67657 9.29535 6.77115 9.41592 6.88651C9.54483 7.00983 9.66165 7.16299 9.76318 7.34171C9.86966 7.52893 9.95553 7.72348 10.0183 7.91968C10.084 8.12476 10.1392 8.35089 10.1824 8.59177C10.2262 8.8363 10.2558 9.0661 10.2703 9.27484V9.27502C10.2852 9.48734 10.2927 9.70926 10.2928 9.93475C10.2927 10.3672 10.1706 10.6936 9.91928 10.9328Z"
                fill={isActive ? ACTIVE_COLOR : SECONDARY_TEXT_COLOR}
            />
        </svg>
    );
}
function LegalCategoryIcon({ isActive }) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.97806 0.75L1.65712 2.05444C1.53105 2.0925 1.44522 2.20798 1.44481 2.33968C1.43963 3.98744 1.2823 7.00513 1.50832 7.67872C2.09642 9.4313 4.16896 10.4616 5.68846 11.1211C5.87947 11.204 6.09664 11.201 6.28632 11.1152C7.82706 10.4176 9.78933 9.50416 10.4584 7.66803C10.6501 7.14198 10.6014 4.01771 10.5314 2.33792C10.5262 2.21228 10.4419 2.10492 10.3215 2.0684L5.97806 0.75Z"
                stroke={isActive ? ACTIVE_COLOR : SECONDARY_TEXT_COLOR}
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.19922 5.77344C4.2732 5.84844 5.23495 6.79844 5.67884 7.27344L8.34216 4.64844"
                stroke="#898996"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
function FinanceCategoryIcon({ isActive }) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM4.90767 5.11023C4.90767 5.47818 5.20702 5.77753 5.57499 5.77753H6.22088C6.92132 5.77753 7.49118 6.3474 7.49118 7.04785C7.49118 7.74829 6.92132 8.31816 6.22088 8.31816H6.19943V8.98551C6.19943 9.15201 6.06444 9.287 5.89793 9.287C5.73142 9.287 5.59643 9.15201 5.59643 8.98551V8.31816H4.92913C4.76263 8.31816 4.62763 8.18317 4.62763 8.01667C4.62763 7.85016 4.76263 7.71517 4.92913 7.71517H6.2209C6.58885 7.71517 6.8882 7.4158 6.8882 7.04785C6.8882 6.6799 6.58885 6.38053 6.2209 6.38053H5.57501C4.87456 6.38053 4.30469 5.81067 4.30469 5.11023C4.30469 4.40979 4.87454 3.83991 5.57501 3.83991H5.59643V3.17259C5.59643 3.00609 5.73142 2.87109 5.89793 2.87109C6.06444 2.87109 6.19943 3.00609 6.19943 3.17259V3.83991H6.86675C7.03326 3.83991 7.16825 3.9749 7.16825 4.14141C7.16825 4.30792 7.03326 4.44291 6.86675 4.44291H5.57499C5.20704 4.44291 4.90767 4.74226 4.90767 5.11023Z"
                fill={isActive ? ACTIVE_COLOR : SECONDARY_TEXT_COLOR}
            />
        </svg>
    );
}
function ArrowIcon({ isActive }) {
    return (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M2.09774 0.0977521C1.96742 0.228077 1.96742 0.438745 2.09774 0.56907L5.52867 4.00001L2.09774 7.43094C1.96742 7.56126 1.96742 7.77193 2.09774 7.90226C2.22807 8.03258 2.43874 8.03258 2.56906 7.90226L6.23565 4.23566C6.30065 4.17066 6.33332 4.08534 6.33332 4C6.33332 3.91465 6.30065 3.82933 6.23565 3.76433L2.56906 0.0977363C2.43874 -0.0325737 2.22807 -0.0325737 2.09774 0.0977521Z"
                    fill={isActive ? ACTIVE_COLOR : TEXT_COLOR}
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect
                        width="8"
                        height="8"
                        fill="white"
                        transform="translate(0 8) rotate(-90)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
const CATEGORY_TYPE = {
    GAMEPLAY: 'GAMEPLAY',
    ACCOUNT: 'ACCOUNT',
    LEGAL: 'LEGAL',
    FINANCE: 'FINANCE'
};
const CATEGORY_LIST = [
    {
        type: CATEGORY_TYPE.GAMEPLAY,
        actions: [
            PLAYER_ACTION_TYPE.BET,
            PLAYER_ACTION_TYPE.WIN,
            PLAYER_ACTION_TYPE.LOST
        ]
    },
    {
        type: CATEGORY_TYPE.ACCOUNT,
        actions: [PLAYER_ACTION_TYPE.NOT_LOGGED_IN, PLAYER_ACTION_TYPE.REGISTER]
    },
    {
        type: CATEGORY_TYPE.LEGAL,
        actions: [
            PLAYER_ACTION_TYPE.KYC_VERIFIED,
            PLAYER_ACTION_TYPE.KYC_NOT_VERIFIED,
            PLAYER_ACTION_TYPE.PHONE_VERIFIED,
            PLAYER_ACTION_TYPE.PHONE_NOT_VERIFIED,
            PLAYER_ACTION_TYPE.EMAIL_VERIFIED,
            PLAYER_ACTION_TYPE.EMAIL_NOT_VERIFIED,
            PLAYER_ACTION_TYPE.SFO_VERIFIED,
            PLAYER_ACTION_TYPE.SFO_NOT_VERIFIED
        ]
    },
    {
        type: CATEGORY_TYPE.FINANCE,
        actions: [
            PLAYER_ACTION_TYPE.WITHDRAW,
            PLAYER_ACTION_TYPE.DEPOSIT,
            PLAYER_ACTION_TYPE.WITHDRAW_APPROVED,
            PLAYER_ACTION_TYPE.WITHDRAW_DECLINED,
            PLAYER_ACTION_TYPE.DEPOSIT_APPROVED,
            PLAYER_ACTION_TYPE.DEPOSIT_DECLINED
        ]
    }
];

function CategoryItem({ category, isActive, setActiveCategory }) {
    const handleMouseOver = useCallback(
        () => setActiveCategory(category),
        [setActiveCategory]
    );

    return (
        <div className={`category ${isActive ? 'active' : ''}`}>
            <div className="category-item" onMouseOver={handleMouseOver}>
                <span>
                    {CATEGORY_TYPE.GAMEPLAY === category.type && (
                        <GameplayCategoryIcon isActive={isActive} />
                    )}
                    {CATEGORY_TYPE.ACCOUNT === category.type && (
                        <AccountCategoryIcon isActive={isActive} />
                    )}
                    {CATEGORY_TYPE.LEGAL === category.type && (
                        <LegalCategoryIcon isActive={isActive} />
                    )}
                    {CATEGORY_TYPE.FINANCE === category.type && (
                        <FinanceCategoryIcon isActive={isActive} />
                    )}

                    {category.type}
                </span>

                <ArrowIcon isActive={isActive} />
            </div>
        </div>
    );
}

function PlayerActionSelect({ onChange, value, isDisabled, ...props }) {
    const areaRef = useRef();
    useClickOutside(areaRef, () => setShowMenu(false));
    useHandleEsc(() => setShowMenu(false));

    const [isShowMenu, setShowMenu] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);

    const handleControlClick = useCallback(() => {
        if (isDisabled) {
            return;
        }

        if (!isShowMenu) {
            const newActiveCategory = CATEGORY_LIST.find(category => {
                return category.actions.find(item => item === value);
            });
            setActiveCategory(newActiveCategory);
        }

        setShowMenu(prevState => !prevState);
    }, [isDisabled, setShowMenu, isShowMenu, value, setActiveCategory]);

    const handleClickAction = useCallback(
        action => {
            return () => {
                setShowMenu(false);
                setActiveCategory(null);
                onChange(action);
            };
        },
        [onChange, setShowMenu, setActiveCategory]
    );

    return (
        <div ref={areaRef} className="player-action-select">
            <AppCommonSelectControl
                onChange={() => {}}
                value={value ? i18n.t(`attributions.constants.${value}`) : ''}
                onClick={handleControlClick}
                isDisabled={isDisabled}
                isShowMenu={isShowMenu}
                placeholder={i18n.t('attributions.selectAction')}
            />

            {isShowMenu && (
                <>
                    <div className="player-action-select__menu">
                        {CATEGORY_LIST.map(category => {
                            return (
                                <CategoryItem
                                    key={category.type}
                                    isActive={
                                        activeCategory?.type === category.type
                                    }
                                    category={category}
                                    setActiveCategory={setActiveCategory}
                                />
                            );
                        })}
                    </div>

                    {activeCategory && (
                        <div className="player-action-select__sub-menu">
                            {activeCategory.actions.map(action => {
                                return (
                                    <div
                                        key={action}
                                        role="button"
                                        className={`action ${
                                            action === value ? 'active' : ''
                                        }`}
                                        onClick={handleClickAction(action)}
                                    >
                                        <div className="action-item">
                                            {i18n.t(
                                                `attributions.constants.${action}`
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

PlayerActionSelect.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default React.memo(PlayerActionSelect);
